import {Box, Button, Form, FormField, Heading, Layer, RadioButtonGroup, Select, TextInput} from "grommet"
import {PARTNERS_GROUP_FEE} from "./SavingIzp";

const EicProductForm = ({onClose, setForm, onSubmit, values, initValues, accountTypeOptions}) => {

	return (<Layer onEsc={() => onClose(false)} onClickOutside={() => onClose(false)}>
	<Box pad="medium">
		<Form
			value={values}
			onChange={nextValue => {
				if(nextValue.successFee === "0"){
					nextValue.successFeeBaseRate = initValues.successFeeBaseRate
				}

                //zmenil sa accountType
                if(nextValue.accountType != values.accountType){
                    nextValue.podielEtf = 100
                    nextValue.equities = 0
                    nextValue.bonds = 0
                    nextValue.mixed = 0
                    nextValue.cashFunds = 0
                    nextValue.otherFunds = 0
                }

                let total = 0;
                if(values.accountType == 6){
                    total += Number(nextValue.podielEtf)
                    total += Number(nextValue.equities)
                    total += Number(nextValue.bonds)
                    total += Number(nextValue.mixed)
                    total += Number(nextValue.cashFunds)

                }else if(values.accountType == 2){
                    total += Number(nextValue.podielEtf)
                    total += Number(nextValue.cashFunds)
                    total += Number(nextValue.otherFunds)               
                   
                }

				if(total > 100)
				{
                    setForm(values)
                    alert("Rozdelenie do jednotlivých nástrojov môže byť maximálne 100%")
                    return
				}
				setForm(nextValue);
			}}
			onSubmit={({ value }) => onSubmit(value) }
		>
			<Heading level="3" margin={{top: "none"}}>Nastavenie parametrov</Heading>

			<Box basis={'auto'} direction={'row-responsive'} align={'center'} wrap>
				<Box direction={'row'} align={'center'} basis={'3/4'} >
					<FormField label="Typ účtu" width={'full'}>
						<RadioButtonGroup direction={'row'} gap={'medium'} name="accountType" options={accountTypeOptions.map(function(v){
							return {value: v.id, label: v.name}
						})} />
					</FormField>
				</Box>
				<Box direction={'row'} align={'center'}  basis={'1/4'} >

				</Box>

				<Box basis={'full'} direction={'row-responsive'} align={'center'} wrap>
					<Box direction={'row'} align={'center'} basis={'1/2'}>
						<FormField label="Vstupný poplatok (%)" width={'full'}>
							<TextInput name="fee" type="number" step="0.1" autoFocus required={true} />
						</FormField>
					</Box>

					<Box direction={'row'} align={'center'} basis={'1/2'}>
						<FormField label="Doba splácania poplatku (m)" width={'full'}>
							<TextInput name="feePeriodInMonths" type="number" step="1" required={true} />
						</FormField>
					</Box>
				</Box>

				{values?.accountType === 6 &&
					<Box basis={'full'} direction={'row-responsive'} align={'center'} wrap>
						<Box direction={'row'} align={'center'} basis={'1/3'}>
							<FormField label="Management fee (%)" width={'full'}>
								<TextInput name="managementFee" type="number" step="0.1" autoFocus required={true} />
							</FormField>
						</Box>

						<Box direction={'row'} align={'center'} basis={'1/3'}>
							<FormField label="Success fee (%)" width={'full'}>
								<TextInput name="successFee" type="number" step="1" required={true} />
							</FormField>
						</Box>

						{values.successFee !== "0" &&
							<Box direction={'row'} align={'center'} basis={'1/3'}>
								<FormField label="Základná sadzba (%)" width={'full'}>
									<TextInput name="successFeeBaseRate" type="number" step="0.10" required={true} />
								</FormField>
							</Box>}
					</Box>

				}

                <Box direction={'row'} basis={'auto'}>
					<FormField label="ETF (%)" width={'full'}>
						<TextInput name="podielEtf" type="number" step="1" required={true} />
					</FormField>
				</Box>
				
                {values?.accountType === 6 &&
                <>
               <Box direction={'row'} basis={'auto'}>
					<FormField width={'auto'} label="Akciové fondy (%)" >
						<TextInput name="equities" type="number" step="1" required={true} />
					</FormField>
				</Box>

				<Box direction={'row'} basis={'auto'}>
					<FormField label="Dlhopisové fondy (%)" width={'full'}>
						<TextInput name="bonds" type="number" step="1" required={true} />
					</FormField>
				</Box>

				<Box direction={'row'} basis={'auto'}>
					<FormField width={'auto'} label="Zmiešané fondy (%)" >
						<TextInput name="mixed" type="number" step="1" required={true} />
					</FormField>
				</Box>
                </>}

                <Box direction={'row'} basis={'auto'}>
					<FormField label="Peňažné fondy (%)" width={'full'}>
						<TextInput name="cashFunds" type="number" step="1" required={true} />
					</FormField>
				</Box>

                {values?.accountType === 2 &&
                <Box direction={'row'} basis={'auto'}>
					<FormField label="Ostatné fondy (%)" width={'full'}>
						<TextInput name="otherFunds" type="number" step="1" required={true} />
					</FormField>
				</Box>
                }
			</Box>


			<Box direction="row" gap="medium" margin={{top:'large'}}>
				<Button type="submit" primary label="Pridať" />
				<Button onClick={() => onClose(false)} label="Zavrieť" />
			</Box>
		</Form>
	</Box>
</Layer>)
}

export default EicProductForm;